import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { List, Column, Table } from 'react-virtualized';
import { Button, Row, FormControl, Col, ControlLabel } from 'react-bootstrap';
import _ from 'lodash';

import { gettext } from '../../../i18n/service.js';
import * as settingsActions from '../../../actions/settingsActions';

class UserTeam extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.state = {};
    this.addedTeams = [];
    this.removedTeams = [];
  }

  componentDidMount() {
    if (!this.props.isEdit) {
      let { userId, userRole } = this.props;
      this.props.settingsActions.getUserTeams(userId, userRole);
    }
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.userId && nextProps.userId !== this.props.userId) {
      this.props.settingsActions.getUserTeams(nextProps.userId, nextProps.userRole);
    }
  }

  addToTeam = (id) => {
    if (id && !this.addedTeams.includes(id)) {
      if (this.removedTeams.includes(id))
        _.pull(this.removedTeams, id);
      this.addedTeams.push(id);
      this.forceUpdate();
    }
    this.props.getTeamsAfterEdit(this.addedTeams, this.removedTeams);
  }

  removeFromTeam = (id) => {
    if (id && !this.removedTeams.includes(id)) {
      if (this.addedTeams.includes(id))
        _.pull(this.addedTeams, id);
      this.removedTeams.push(id);
      this.forceUpdate();
    }
    this.props.getTeamsAfterEdit(this.addedTeams, this.removedTeams);
  }

  teamsRowRenderer({
    key,         // Unique key within array of rows
    index,       // Index of row within collection
    isScrolling, // The List is currently being scrolled
    isVisible,   // This row is visible within the List (eg it is not an overscanned row)
    style        // Style object to be applied to row (to position it)
  }, teams, teamMembers) {
    let className = '';
    if (teamMembers) {
      if (this.state.selectedTeamForUnAssign === teams[index].id)
        className = 'active';
    } else {
      if (this.state.selectedTeamForAssign === teams[index].id)
        className = 'active';
    }
    return (
      <div
        key={key}
        style={style}
        className={className}
        onClick={() => {
          teamMembers
            ? this.setState({ selectedTeamForUnAssign: teams[index].id })
            : this.setState({ selectedTeamForAssign: teams[index].id });
        }} >
        {teams[index].name}
      </div>
    )
  }

  renderEdit() {
    let { userTeams, teams } = this.props;

    //Filter items after addTo/removeFrom team
    this.addedTeams.map((team) => {
      let findedTeam = _.find(this.props.teams, { id: team });
      if (findedTeam) {
        _.pull(teams, findedTeam);
        userTeams.push(findedTeam);
      }
    });
    this.removedTeams.map((team) => {
      let findedTeam = _.find(this.props.userTeams, { id: team });
      if (findedTeam) {
        _.pull(userTeams, findedTeam);
        teams.push(findedTeam);
      }
    });

    //Order by name
    userTeams = _.orderBy(userTeams, ['name'], ['asc']);
    teams = _.orderBy(teams, ['name'], ['asc']);

    //All teams list, exclude user's teams
    teams = _.filter(teams, (team) => {
      let isUserInTeam = _.find(userTeams, { id: team.id });
      return !isUserInTeam;
    });

    //Apply filters
    if (this.state.userTeamsFilter)
      userTeams = _.filter(userTeams, (team) => {
        return (team.name &&
          team.name.toUpperCase().indexOf(this.state.userTeamsFilter.toUpperCase()) != -1);
      });

    if (this.state.userAllTeamsFilter)
      teams = _.filter(teams, (team) => {
        return (team.name &&
          team.name.toUpperCase().indexOf(this.state.userAllTeamsFilter.toUpperCase()) != -1);
      });

    //Clear duplicates
    teams = _.uniqBy(teams, 'id');
    userTeams = _.uniqBy(userTeams, 'id');
    return (
      <div className="user_data center_div">
        <Row>
          <Col sm={5}>
            <ControlLabel><h4>{gettext('ALL-TEAMS')}: {teams.length}</h4></ControlLabel>
            <FormControl
              type="text"
              placeholder={gettext('SEARCH')}
              onChange={(e) => { this.setState({ userAllTeamsFilter: e.target.value }) }} />
            <div className="team_user_select">
              <List
                width={300}
                height={200}
                rowCount={teams.length}
                rowHeight={20}
                rowRenderer={(e) => this.teamsRowRenderer(e, teams, true)}
              />
            </div>
          </Col>
          <Col sm={2}>
            {this.props.isEdit ?
              <div className="teamlist_controls">
                <div className="teamlist_button_container">
                  <Button bsStyle="primary"
                    onClick={() => {
                      this.addToTeam(this.state.selectedTeamForUnAssign);
                    }}></Button>
                </div>
                <div className="teamlist_button_container">
                  <Button bsStyle="primary"
                    onClick={() => {
                      this.removeFromTeam(this.state.selectedTeamForAssign);
                    }}></Button>
                </div>
              </div> : ''
            }
          </Col>
          <Col sm={5}>
            <ControlLabel><h4>{gettext('TEAMS')}</h4></ControlLabel>
            <FormControl
              type="text"
              placeholder={gettext('SEARCH')}
              onChange={(e) => { this.setState({ userTeamsFilter: e.target.value }) }} />
            <div className="team_user_select">
              <List
                width={300}
                height={200}
                rowCount={userTeams.length}
                rowHeight={20}
                rowRenderer={(e) => this.teamsRowRenderer(e, userTeams)}
              />
            </div>
          </Col>
        </Row>
      </div>
    );
  }

  renderView() {
    let { userTeams } = this.props;
    userTeams = _.orderBy(userTeams, ['name'], ['asc']);
    if (this.state.userTeamsFilter)
      userTeams = _.filter(userTeams, (team) => {
        return (team.name &&
          team.name.toUpperCase().indexOf(this.state.userTeamsFilter.toUpperCase()) != -1);
      });

    return (
      <div className="user_data center_div">
        <Row>
          <Col sm={12}>
            <FormControl
              type="text"
              style={{ marginBottom: '1em' }}
              placeholder={gettext('SEARCH')}
              onChange={(e) => this.setState({ userTeamsFilter: e.target.value })} />
            <div className="table_container">
              <Table
                width={300}
                height={200}
                headerHeight={20}
                rowHeight={30}
                rowCount={userTeams.length}
                rowGetter={({ index }) => userTeams[index]}>
                <Column
                  label='Name'
                  dataKey='name'
                  width={500}
                />
              </Table>
            </div>
          </Col>
        </Row>
      </div>
    );
  }

  render() {
    return (
      <div>
        {
          this.props.isEdit
            ? this.renderEdit()
            : this.renderView()
        }
      </div>
    );
  }
}

UserTeam.propTypes = {

};

function mapStateToProps(state) {
  return {
    userTeams: state.settingsPageReducer.userTeams,
    teams: state.settingsPageReducer.teams
  };
}

function mapDispatchToProps(dispatch) {
  return {
    settingsActions: bindActionCreators(settingsActions, dispatch)
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(UserTeam);


// WEBPACK FOOTER //
// ./src/components/settings/components/UserTeams.js